module.exports = __webpack_public_path__ + "static/img/pan.332aca0c.png";